import type { LibraryAgentContextValue } from "./hooks/library-agent-context";

type LibraryAgentListener = (value: LibraryAgentContextValue | null) => void;

let registered: LibraryAgentContextValue | null = null;
const listeners = new Set<LibraryAgentListener>();

function notify() {
	for (const listener of listeners) {
		listener(registered);
	}
}

export function registerLibraryAgent(value: LibraryAgentContextValue) {
	registered = value;
	notify();

	return () => {
		if (registered === value) {
			registered = null;
			notify();
		}
	};
}

export function getLibraryAgent() {
	return registered;
}

export function subscribeLibraryAgent(listener: LibraryAgentListener) {
	listeners.add(listener);
	listener(registered);

	return () => {
		listeners.delete(listener);
	};
}

export function resetLibraryAgentRegistryForTests() {
	registered = null;
	listeners.clear();
}
